import { fireFbAddToCart, getPriceParams } from './productPageUtils';
import {
  checkProductLength,
  getRandomEventId,
  getScreenName,
  replacePriceSymbol,
} from './helper';
import { getWebUserType } from './getWebUserType';
import { fireEvent } from './fireEvent';

export const replaceTabWithAll = (key) => {
  if (key?.includes('_tab_')) {
    return key.replace('_tab_', '_all_');
  }
  return key;
};

export const showPricePerUnit = (userType, pricePerUnit) => {
  //return userType === "B";
  return pricePerUnit?.length > 0;
};

export const getCategoryRedirectUrl = (category) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.delete('subcategory');
  if (category?.parentKey) {
    if (replaceTabWithAll(category?.parentKey) !== category?.key) {
      urlSearchParams.set('subcategory', category?.key);
    }
    return `/category/${
      replaceTabWithAll(category?.parentKey) + '?' + urlSearchParams.toString()
    }`;
  } else if (category?.key) {
    return (
      '/category/' +
      replaceTabWithAll(category?.key) +
      '?' +
      urlSearchParams.toString()
    );
  } else if (category?.fabDeeplinkValue) {
    window.location.href =
      category?.fabDeeplinkValue + '?' + urlSearchParams.toString();
  }
};

export const fireServedEvent = (item, category_name) => {
  let itemIds = [];
  if (item?.items?.length > 0) {
    for (let product of item?.items) {
      if (itemIds.length > 20) break;
      itemIds.push(product?._id);
    }
  }
  fireEvent({
    category: 'served_section_in_myloshop',
    screen_name: 'category',
    category_name: category_name,
    section_id: item?._id,
    card_ids: itemIds,
    section_name: item?.heading,
    shape: item?.itemType,
    page_url: window.location.href.slice(0, 99),
  });
};
export const clickedCardEvent = (
  section,
  card,
  category_name,
  deeplinkUrl,
  fromBabyNames,
) => {
  fireEvent({
    category: fromBabyNames
      ? 'clicked_card_in_general_screen'
      : 'clicked_card_in_myloshop',
    screen_name: getScreenName(),
    category_name: category_name,
    section_id: section?._id,
    card_id: card?._id,
    section_name: section?.heading || category_name,
    user_type: getWebUserType(),
    deeplink: card?.deeplink,
    deeplink_value: deeplinkUrl,
    card_name: card?.name || card?.tabName,
    shape: card?.itemType,
    page_url: window.location.href.slice(0, 99),
  });
};

export const addGoToCartEvent = (
  event,
  section,
  product,
  category_name,
  parentTag,
) => {
  const productCopy = { ...product };
  productCopy.price = replacePriceSymbol(product?.price);
  productCopy.strikePrice = replacePriceSymbol(product?.strikePrice);
  const { pricingParam, conversionParam } = getPriceParams(productCopy);
  const isAddToCart = event === 'clicked_add_to_cart';
  const RandomEventId = getRandomEventId();
  const nickname = productCopy?.nickname
    ? checkProductLength(productCopy?.nickname)
    : checkProductLength(productCopy?.name);
  fireEvent({
    category: event,
    screen_name: getScreenName(),
    id: productCopy?._id,
    category_name: category_name,
    sku_name: productCopy?.name,
    selling_price: productCopy?.price,
    sku_nickname: nickname,
    section_id: section?._id,
    section_name: section?.heading ||  section?.itemType|| category_name,
    user_type: getWebUserType(),
    parent: parentTag,
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    event_id: RandomEventId,
  });
  if (isAddToCart) {
    fireFbAddToCart(productCopy, RandomEventId);
  }
};
export const clickedLoadMoreEvent = (section, category_name) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'category',
    section_name: section?.heading,
    category_name: category_name,
    cta: 'load_more_products',
    user_type: getWebUserType(),
  });
};
export const clickCategoryEvent = (name, category_name) => {
  fireEvent({
    category: 'clicked_category_subtab',
    screen_name: 'category',
    name: name,
    parent: category_name,
    user_type: getWebUserType(),
  });
};

export const appliedFilterEvent = (name) => {
  fireEvent({
    category: 'applied_filter',
    screen_name: 'category',
    //section_name : "",
    name,
    page_url: window.location.href.slice(0, 99),
  });
};

export const fireFilterServeEvent = (item, category_name) => {
  let itemIds = [];
  if (item?.length > 0) {
    for (let product of item) {
      if (itemIds.length > 20) break;
      itemIds.push(product?._id || product?.term_id);
    }
  }
  fireEvent({
    category: 'served_section_in_myloshop',
    screen_name: 'category',
    category_name: category_name,
    section_id: item?._id,
    card_ids: itemIds,
    section_name: 'Browse Related Categories',
    page_url: window.location.href.slice(0, 99),
  });
};

export const browseAllCategoriesClickEvent = (item, category_name) => {
  fireEvent({
    category: 'clicked_card_in_myloshop',
    screen_name: 'category',
    category_name: category_name,
    section_id: item?._id || item?.term_id,
    // card_id: card?._id,
    section_name: 'Browse Related Categories',
    // user_type: getWebUserType(),
    deeplink: item?.webUrl || item?.web_url,
    //deeplink_value: deeplinkUrl,
    card_name: item?.tabName || item?.description,
    //shape: card?.itemType,
    page_url: window.location.href.slice(0, 99),
  });
};

export const showAffordWidget = (userType, productId) => {
  const arr = [2631, 2632];
  // return userType === "B" && arr.includes(Number(productId));
  return false;
};
